/** This is an automatically generated class by FairyGUI. Please do not modify it. **/
export default class UI_btn_custom_2 extends fgui.GButton {
    static createInstance() {
        return (fgui.UIPackage.createObject("Main", "btn_custom_2"));
    }
    onConstruct() {
        this.m_c1 = this.getControllerAt(1);
    }
}
UI_btn_custom_2.URL = "ui://c6t3i6k8mc617x";
